const filterSelectionTag = {
  processing: false,
  track: () => {
    if (this.processing) {
      console.debug("already processing filterSelectionTag")
      checkProductCardsPromoTextHeight()
      return
    }
    this.processing = true
    setTimeout(() => {
      const selectedColors = []
      const selectedAvailabilities = []
      const selectedFamilies = [] // ?
      const selectedTypes = [] // ?
      const selectedImprove = [] // custom.improve_your
      const selectedTherapies = [] // custom.therapies
      const selectedCollections = [] // custom.collections
      const selectedPopular = [] // custom.most_popular

      const sort = document
        .querySelector('.mobile-facets__checkbox[name="sort_by"][checked]')
        ?.parentElement?.querySelector(".facet-checkbox__text")
        ?.textContent?.trim()

      document
        .querySelectorAll('.mobile-facets__checkbox[name*="color"]:checked')
        .forEach(function (checkbox) {
          selectedColors.push(checkbox.value)
        })

      document
        .querySelectorAll(
          '.mobile-facets__checkbox[name*="availability"]:checked',
        )
        .forEach(function (checkbox) {
          const label = checkbox.closest("label")
          const availabilityText = label
            .querySelector(".facet-checkbox__text-label")
            .innerText.trim()
          selectedAvailabilities.push(availabilityText)
        })

      document
        .querySelectorAll('.mobile-facets__checkbox[name*="family"]:checked')
        .forEach(function (checkbox) {
          selectedFamilies.push(checkbox.value)
        })

      document
        .querySelectorAll('.mobile-facets__checkbox[name*="type"]:checked')
        .forEach(function (checkbox) {
          selectedTypes.push(checkbox.value)
        })

      document
        .querySelectorAll(
          '.mobile-facets__checkbox[name*="improve_your"]:checked',
        )
        .forEach(function (checkbox) {
          selectedImprove.push(checkbox.value)
        })

      document
        .querySelectorAll('.mobile-facets__checkbox[name*="therapies"]:checked')
        .forEach(function (checkbox) {
          selectedTherapies.push(checkbox.value)
        })

      document
        .querySelectorAll(
          '.mobile-facets__checkbox[name*="collections"]:checked',
        )
        .forEach(function (checkbox) {
          selectedCollections.push(checkbox.value)
        })

      document
        .querySelectorAll(
          '.mobile-facets__checkbox[name*="most_popular"]:checked',
        )
        .forEach(function (checkbox) {
          selectedPopular.push(checkbox.value)
        })

      dataLayer.push({
        event: "advanced_filter_selection",
        sort: sort,
        // filter_color: selectedColors,
        // filter_availability: selectedAvailabilities,
        // filter_product_family: selectedFamilies,
        // filter_product_type: selectedTypes,
        filter_improve_your: selectedImprove,
        filter_therapy: selectedTherapies,
        filter_collection: selectedCollections,
        filter_most_popular: selectedPopular,
      })
      setTimeout(() => (this.processing = false), 1000)
    }, 1000)
  },
}
